import { Box, Typography, Container } from "@mui/material";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function AboutHeroSection() {
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "300px", md: "420px" },
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        color: "#fff",
      }}
    >
      {/* Background Image */}
      <img
        src="https://lh3.googleusercontent.com/gps-cs-s/AG0ilSzs5m5iUK3C2CdOwDf9aYccwSmuUQCDqwe4PRd1id7Y05M49wmf7MYqkOofJnKONavfzPUp8isa8JECnXlAATNm95OGbZW-k_8slD1kCImgL9ixoxy80tQKP5qRhjayKN2TNPVKbbkCDZQ=s1360-w1360-h1020-rw"
        alt="About Hero"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: 1,
        }}
      />

      {/* Branded Blue Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
            background: `${brandBlue}CC`, // blue tint with opacity
        //   background:
        //     "linear-gradient(135deg, rgba(26,35,126,0.8), rgba(213,0,0,0.8))",
          zIndex: 2,
        }}
      />

      {/* Text Content */}
      <Container maxWidth="lg" sx={{ position: "relative", zIndex: 3 }}>
        <Typography
          variant="h3"
          fontWeight={800}
          sx={{
            mb: 2,
            fontSize: { xs: "1.8rem", md: "3rem" },
            textTransform: "uppercase",
            letterSpacing: "1px",
          }}
        >
          About Our Company
        </Typography>

        {/* Small red underline accent */}
        <Box
          sx={{
            width: "80px",
            height: "4px",
            background: brandRed,
            mx: "auto",
            borderRadius: 2,
            mb: 3,
          }}
        />

        <Typography
          variant="h6"
          sx={{
            opacity: 0.95,
            fontSize: { xs: "1rem", md: "1.25rem" },
            maxWidth: "700px",
            mx: "auto",
          }}
        >
          Delivering Excellence in Metal Engineering & Industrial Manufacturing Solutions
        </Typography>
      </Container>
    </Box>
  );
}
